import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';

export const CategorySelect = {
  id: 'category-filter-select',
  contentTypeId: 'dynamic-elements-filter-select',
  data: {
    options: {
      provider: 'HttpBodyProvider',
      property: {
        values: [
          {
            provider: 'id:root',
            property: 'accountId',
          },
          {
            provider: 'id:root',
            property: 'brandId',
          },
          {
            provider: 'id:root',
            property: 'fromDate',
          },
          {
            provider: 'id:root',
            property: 'toDate',
          },
        ],
        transform: function ([accountId, brandId, fromDate, toDate]: string[]) {
          return `/api/v2/reporting/orderhistoryproducts/filters?AccountId=${accountId}&BrandId=${brandId}&FromDate=${fromDate}&ToDate=${toDate}`;
        }.toString(),
      },
      transform: function (res: string): {
        displayValue: string;
        value: string;
      } {
        const parsed = JSON.parse(res);
        const mapped = parsed.categories.map(
          (category: { key: string; value: string }) => ({
            name: category.value,
            displayName: category.key,
          }),
        );
        return mapped;
      }.toString(),
    },
  },
  inputs: {
    filterItem: {
      provider: 'self',
      property: 'options',
      startWith: {
        values: [],
      },
      transform: function (options: any) {
        return {
          isSingle: true,
          values: options,
        };
      }.toString(),
    },
    activeValues: {
      provider: 'id:root',
      property: 'selectedCategory',
      startWith: [],
      transform: function ($event: any) {
        return $event ?? [];
      }.toString(),
    },
    fieldDisplayName: recommendationsPanelsLocaleKeys.filterByCategory,
    selectedValuesAsLabel: true,
  },
  styles: {
    dynamicVariables: {
      provider: 'id:root',
      property: 'filterSelectVariables',
    },
  },
};
